export function getView(value) {
  return value ? 'IconOnly' : 'IconAndTitle'
}
